export enum BannerSource {
  Adriver = 'adriver',
  Admanager = 'admanager',
}

export type SetBannerSource = (value: BannerSource) => void;

export type SetIsAdriverTopBannerVisible = (value: boolean) => void;

export interface BannerStore {
  isBlockerDetected: boolean;
  setBlockerDetector: (value: boolean) => void;
  canLoadBanners: boolean;
  setCanLoadBanners: (value: boolean) => void;
  bannerTopSource: BannerSource;
  setBannerTopSource: SetBannerSource;
  bannerBottomSource: BannerSource;
  setBannerBottomSource: SetBannerSource;
  bannerBackgroundSource: BannerSource;
  setBannerBackgroundSource: SetBannerSource;
  isAdriverTopBannerVisible: boolean;
  setIsAdriverTopBannerVisible: SetIsAdriverTopBannerVisible;
  resetBannersState: () => void;
}
